"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopperContentContainer = exports.StyledPopper = exports.MenuContainer = exports.SiteStatusIndicatorText = exports.SiteStatusIndicator = exports.LastEditedText = exports.SiteStatusIndicatorContainer = exports.SiteDetails = exports.DescriptionBox = exports.GroupItemContainer = exports.StyledMenuItem = exports.SiteName = exports.SiteThumbnail = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Chip = _interopRequireDefault(require("@eig-builder/core-ui/Chip"));

var _MenuItem = _interopRequireDefault(require("@eig-builder/core-ui/MenuItem"));

var _Typography = _interopRequireDefault(require("@eig-builder/core-ui/Typography"));

var _Popper = _interopRequireDefault(require("@eig-builder/core-ui/Popper"));

var _Paper = _interopRequireDefault(require("@eig-builder/core-ui/Paper"));

function _templateObject15() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  max-height: 60vh;\n  overflow: auto;\n  margin-top: ", "px;\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = (0, _taggedTemplateLiteral2["default"])(["calc(100vw - ", "px)"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  z-index: 5000;\n  width: ", ";\n  padding-left: 1px;\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  margin-left: ", "px;\n  display: flex;\n  height: 100%;\n  width: fit-content;\n  max-width: 100%;\n  align-items: center;\n  padding: ", ";\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.05);\n    cursor: pointer;\n  }\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  height: ", "px;\n  background-color: ", ";\n  color: ", ";\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  align-self: ", ";\n  margin-left: ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  margin-left: ", "px;\n  margin-right: ", "px;\n  flex-grow: 1;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  width: 100%;\n  flex-direction: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  width: 100%;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  height: auto;\n  padding: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["url(", ")"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  position: relative;\n  background-size: cover;\n  background-position: top center;\n  background-repeat: no-repeat;\n  background-image: ", ";\n  flex-shrink: 0;\n  ::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border-radius: 50%;\n    background: ", ";\n    z-index: -1;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SiteThumbnail = _styledComponents["default"].div(_templateObject(), function (_ref) {
  var screenshot = _ref.screenshot;
  return screenshot && (0, _styledComponents.css)(_templateObject2(), screenshot);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.black.light;
});

exports.SiteThumbnail = SiteThumbnail;

var SiteName = _styledComponents["default"].div(_templateObject3());

exports.SiteName = SiteName;
var StyledMenuItem = (0, _styledComponents["default"])(_MenuItem["default"])(_templateObject4(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacing(3, 4);
});
exports.StyledMenuItem = StyledMenuItem;

var GroupItemContainer = _styledComponents["default"].div(_templateObject5());

exports.GroupItemContainer = GroupItemContainer;

var DescriptionBox = _styledComponents["default"].div(_templateObject6(), function (_ref4) {
  var isMobile = _ref4.isMobile;
  return isMobile ? 'column' : 'row';
});

exports.DescriptionBox = DescriptionBox;

var SiteDetails = _styledComponents["default"].div(_templateObject7(), function (_ref5) {
  var theme = _ref5.theme;
  return theme.spacing(3);
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.spacing(10);
});

exports.SiteDetails = SiteDetails;

var SiteStatusIndicatorContainer = _styledComponents["default"].div(_templateObject8(), function (_ref7) {
  var isMobile = _ref7.isMobile;
  return isMobile ? 'flex-start' : 'center';
}, function (_ref8) {
  var isMobile = _ref8.isMobile,
      theme = _ref8.theme;
  return isMobile ? "".concat(theme.spacing(2), "px") : 'initial';
});

exports.SiteStatusIndicatorContainer = SiteStatusIndicatorContainer;
var LastEditedText = (0, _styledComponents["default"])(_Typography["default"])(_templateObject9(), function (_ref9) {
  var theme = _ref9.theme;
  return theme.palette.black.light;
});
exports.LastEditedText = LastEditedText;
var SiteStatusIndicator = (0, _styledComponents["default"])(_Chip["default"])(_templateObject10(), function (_ref10) {
  var theme = _ref10.theme;
  return theme.spacing(5);
}, function (_ref11) {
  var theme = _ref11.theme,
      published = _ref11.published;
  return published ? theme.palette.green.main : theme.palette.orange.main;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.palette.white.main;
});
exports.SiteStatusIndicator = SiteStatusIndicator;
var SiteStatusIndicatorText = (0, _styledComponents["default"])(_Typography["default"])(_templateObject11(), function (_ref13) {
  var theme = _ref13.theme;
  return theme.palette.white.main;
});
exports.SiteStatusIndicatorText = SiteStatusIndicatorText;

var MenuContainer = _styledComponents["default"].div(_templateObject12(), function (_ref14) {
  var isMobile = _ref14.isMobile;
  return isMobile ? 0 : 28;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.spacing(0, 4);
});

exports.MenuContainer = MenuContainer;
var StyledPopper = (0, _styledComponents["default"])(_Popper["default"])(_templateObject13(), function (_ref16) {
  var isMobile = _ref16.isMobile,
      theme = _ref16.theme;
  return isMobile ? (0, _styledComponents.css)(_templateObject14(), theme.spacing(2)) : 'initial';
});
exports.StyledPopper = StyledPopper;
var PopperContentContainer = (0, _styledComponents["default"])(_Paper["default"])(_templateObject15(), function (_ref17) {
  var theme = _ref17.theme;
  return theme.spacing(1);
});
exports.PopperContentContainer = PopperContentContainer;